import moment from 'moment';
import { Button, Image } from 'semantic-ui-react';
import { profileImage } from '../../helpers/index';

import VolunteerForm from '../../../containers/experience/volunteersLogs/VolunteerForm';
import { ShowGuestLeaders } from '../../../containers/membersLeader/showLeaders';

export const volunteersRowDef = ({
  setOpenVolLeaders,
  openVolLeaders,
  showVolunteerForm,
  set_showVolunteerForm,
  loading,
  set_loading,
  getInfo,
  showImgs,
  churchMinistries,
  showDeletedReason = false,
  showSubsection = false,
}) => {
  return [
    // Personal Information Group
    {
      headerName: 'Información Personal',
      children: [
        { headerName: 'Cédula', width: 120, field: 'identification' },
        ...(showImgs
          ? [
              {
                headerName: 'Image',
                width: 100,
                field: 'image',
                cellRenderer: (params) => (
                  <Image src={profileImage(params.data)} rounded size="small" />
                ),
              },
            ]
          : []),
        { headerName: 'Nombres', width: 120, field: 'name' },
        { headerName: 'Apellidos', width: 150, field: 'lastName' },
        { headerName: 'Celular', field: 'phone', width: 150 },
      ],
    },

    // Service Information Group
    {
      headerName: 'Información de Servicio',
      children: [
        {
          headerName: 'Area de Servicio',
          field: 'serviceArea',
          width: 150,
          cellRenderer: (params) => (
            <p style={{ margin: '0' }}>{params.data?.serviceArea?.replace(/_/g, ' ')}</p>
          ),
          valueGetter: (val) =>
            churchMinistries.find((role) => role.key === val.data?.serviceArea)?.name ||
            val.data?.serviceArea,
        },
        {
          headerName: 'Rol',
          field: 'role',
          width: 130,
          cellRenderer: (params) => (
            <p style={{ margin: '0' }}>
              {params.data?.role === 'Coordinador' ? (
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`/experiencia/voluntarios?phone=${params.data.phone}&identification=${params.data.identification}&serviceArea=${params.data.serviceArea}`}
                >
                  <Button basic color="black" size="mini">
                    {params.data?.role}
                  </Button>
                </a>
              ) : (
                params.data?.role?.replace(/_/g, ' ')
              )}
            </p>
          ),
        },
        {
          headerName: 'Sección',
          field: 'section',
          width: 150,
          valueGetter: (val) => `${val.data?.section?.replace(/_/g, ' ')}`,
        },
        ...(showSubsection
          ? [
              {
                headerName: 'Subsección',
                field: 'subsection',
                width: 160,
                valueGetter: (val) => val.data?.subsection?.replace(/_/g, ' ') || '',
              },
            ]
          : []),
      ],
    },

    ...(showDeletedReason
      ? [
          {
            headerName: 'Eliminación',
            children: [
              { headerName: 'Razón', field: 'deletedReason', width: 240 },
              {
                headerName: 'Fecha',
                field: 'deletedAt',
                width: 160,
                valueGetter: (val) =>
                  val.data?.deletedAt ? moment(val.data.deletedAt).format('DD-MM-YYYY HH:mm') : '',
              },
            ],
          },
        ]
      : []),

    // Status and Management Group
    {
      headerName: 'Estado y Gestión',
      children: [
        {
          headerName: 'Docs',
          field: 'documents',
          width: 90,
          valueGetter: (val) => {
            if (val.data?.documentSideA && val.data?.documentSideB) return 2;
            if (val.data?.documentSideA || val.data?.documentSideB) return 1;
            return 0;
          },
        },
        {
          headerName: 'Lideres',
          field: 'leaders',
          width: 110,
          cellRenderer: (params) => (
            <ShowGuestLeaders
              Guest={params.data}
              buttonText="Ver"
              setOpenVolLeaders={(open) => {
                setOpenVolLeaders(open ? params.data.id : null);
              }}
              openVolLeaders={params.data.id === openVolLeaders}
              getInfo={getInfo}
              set_loading={set_loading}
              loading={loading}
            />
          ),
        },
        {
          headerName: 'Convenio',
          field: 'convenio',
          width: 100,
          valueGetter: (val) => `${val.data?.convenio ? 'Si' : 'No'}`,
        },
        {
          headerName: 'Suspendido',
          field: 'suspended',
          width: 100,
          valueGetter: (val) => `${val.data?.suspended ? 'Si' : 'No'}`,
        },
      ],
    },

    // Actions Group
    {
      headerName: 'Acciones',
      children: [
        {
          headerName: showDeletedReason ? 'Recuperar' : 'Editar',
          field: 'actions',
          width: 120,
          sortable: false,
          filter: false,
          cellRenderer: (params) => (
            <>
              <Button disabled={loading} onClick={() => set_showVolunteerForm(params.data.id)}>
                {showDeletedReason ? 'Recuperar' : 'Editar'}
              </Button>
              {showVolunteerForm === params.data.id && (
                <VolunteerForm
                  prevVolunteerInputs={params.data}
                  set_showVolunteerForm={set_showVolunteerForm}
                  set_loading={set_loading}
                  getInfo={getInfo}
                  loading={loading}
                />
              )}
            </>
          ),
        },
      ],
    },
  ];
};
